const getPaypalConfig = state => state?.paypal?.paypalConfig;
const getPaypalStatus = state => state?.paypal?.status;
const getPaypalError = state => state?.paypal?.error;

export { getPaypalStatus, getPaypalError, getPaypalConfig };
